// An authorized report supplies metadata for its own saved fields. Keep the
// ordinary picker authoritative for editing and never broaden a new catalog.
export const mergeSavedReportCustomFields = (catalogFields, savedFields) => {
    const fields = new Map((Array.isArray(catalogFields) ? catalogFields : [])
        .map(field => [String(field.id), field]));
    for (const field of Array.isArray(savedFields) ? savedFields : []) {
        if (!field || !/^[1-9][0-9]*$/.test(String(field.id))
            || Number(field.field_id) === 28
            || ![0, 1].includes(Number(field.hidden ?? 0))
            || Number(field.obsolete ?? 0) !== 0) continue;
        const key = String(field.id);
        if (!fields.has(key)) fields.set(key, { ...field, edit: 0, _savedReportField: true });
    }
    return [...fields.values()];
};
